module.exports = {
    /************************
    Change type : Error message Implementation in CPP v1.0
    Changed by: Sai Aman Pothuganti
    Date : 05-06-2020
    ************************/  
    //2353
    T01: "We’re having some technical difficulties. Please try again later  or call us at 1-800-447-6620. Error Code 2353 - T01.",
    B02: "We're sorry, but we're unable to process your request. Please try again later, or call us at 1-800-655-4555. Error Code 2353 - B02.",

    //619
    E01: "We're sorry, but we're unable to process your request. Please try again later, or call us at 1-800-655-4555. Error Code 619 - E01.",

    //616
    21: "We're sorry, but we're unable to process your request. Please try again later, or call us at 1-800-655-4555. Error Code 616 - 21.",

    //Default
    DEFAULT: "We're having some technical difficulties. Please try again later  or call us at 1-800-447-6620",
}; 